import { Helmet } from 'react-helmet-async';
import { Card, CardHeader, CardTitle, CardContent } from '@bloomcode/ui';
import { useCookieSession } from '@bloomcode/auth';

export default function DashboardPage() {
  const { session } = useCookieSession();

  return (
    <>
      <Helmet>
        <title>Dashboard - Bloomcode CMS Portal</title>
      </Helmet>

      <div className="container mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-8">
          Welcome back, {session?.name || 'User'}!
        </h1>

        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          <Card>
            <CardHeader>
              <CardTitle>Getting Started</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-muted-foreground">
                Start building your dashboard here.
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </>
  );
}
